import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  getHomePictreeCheckInCommon,
  getPictreeDataCheckInTrendCommon,
  setCurrentPage,
  setPictreeChartSize,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CheckInCommon from "components/PicTree/Home/CheckInCommon";
import ChartConfig from "utils/ChartConfig";
import LineChartPictreeCheckIn from "components/Charts/LineChartPictreeCheckIn";
import PicTreeTableCheckIn from "components/Table/PicTreeTableCheckIn";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";

const useStyles = makeStyles((theme) => ({
  loaderBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 280,
  },
  loaderBarImg: { width: 40 },
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  selectGameTxt: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 280,
  },
}));

const PicTreeCheckInCommon = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTreeCommon,
  checkInTrendData,
  getHomePictreeCheckInCommon,
  getPictreeDataCheckInTrendCommon,
  setPictreeChartSize,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "日別", value: "day" });
  const [initialDataCall, setInitialDataCall] = useState(true);
  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, [setCurrentPage]);

  useEffect(() => {
    if (
      dateRangePicTreeCommon[0] !== null &&
      dateRangePicTreeCommon[1] !== null &&
      initialDataCall
    ) {
      const dateRange = dateRangePicTreeCommon;
      getHomePictreeCheckInCommon({ dateRange });
      getPictreeDataCheckInTrendCommon({ chartSize: "day", dateRange });
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeCommon, initialDataCall, getHomePictreeCheckInCommon, getPictreeDataCheckInTrendCommon]);

  const handleChange = (event) => {
    const nextChartSize = event.target.value;
    setChartSize(nextChartSize);
    setPictreeChartSize(nextChartSize);
    getPictreeDataCheckInTrendCommon({
      chartSize: nextChartSize,
      dateRange: dateRangePicTreeCommon,
    });
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={0} direction="row" style={{ marginTop: -16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 汎用事業者</Typography>
              <Typography variant="body1">チェックイン</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace} />
          <Grid item>
            <CalendarRangePicTreeCommon
              mDate="2026/09/01"
              page="pictree"
              pictree
            />
          </Grid>
        </Grid>

        <Grid container spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <CheckInCommon />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={0} direction="row" style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item style={{ marginTop: 0, marginLeft: 48 }}>
            <SingleSelect
              selected={chartSize}
              options={[
                { name: "時間別", value: "hour" },
                { name: "日別", value: "day" },
              ]}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12}>
            {pageTopLoader ? (
              <div className={classes.loaderBox}>
                <img className={classes.loaderBarImg} src="/static/images/loader-bar.gif" alt="" />
              </div>
            ) : checkInTrendData.length > 0 ? (
              <LineChartPictreeCheckIn
                legend={ChartConfig.legendPicTreeTrend}
                lblSaveImage=""
                xAisData={checkInTrendData[0].date.map((date) =>
                  chartSize.value === "hour"
                    ? moment.utc(date).format("YYYY-MM-DD HH:00")
                    : moment.utc(date).format("YYYY-MM-DD")
                )}
                seriesData={checkInTrendData}
                chartType="line"
              />
            ) : (
              <div className={classes.selectGameTxt}>
                <Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />
              </div>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12}>
            <PicTreeTableCheckIn
              game="PicTree"
              common
              dateRange={dateRangePicTreeCommon}
            />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeCheckInCommon.propTypes = {
  setCurrentPage: PropTypes.func.isRequired,
  dateRangePicTreeCommon: PropTypes.array.isRequired,
  checkInTrendData: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  checkInTrendData: state.pictreeCommon.checkInTrend || [],
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getHomePictreeCheckInCommon: (param) => dispatch(getHomePictreeCheckInCommon(param)),
  getPictreeDataCheckInTrendCommon: (param) => dispatch(getPictreeDataCheckInTrendCommon(param)),
  setPictreeChartSize: (param) => dispatch(setPictreeChartSize(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeCheckInCommon);
